import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const footerButtonsContainer = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  background-color: ${theme.palette.background.paper};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  flex-direction: row-reverse;
  z-index: 1;

  button {
    background-color: ${theme.palette.uintel[400]};
  }
`

export const tooltipArrow = (arrowColor: string) => css`
  position: absolute;
  width: 8px;
  height: 16px;
  left: -8px;
  bottom: 12px;
  background-color: ${arrowColor};
  clip-path: polygon(100% 0%, 0% 50%, 100% 100%);
`
